import { defineMessages } from "react-intl";

export default defineMessages({
  finnish: {
    id: "languages.finnish",
    defaultMessage: "suomi"
  },
  inFinnish: {
    id: "languages.inFinnish",
    defaultMessage: "Suomeksi"
  },
  inSwedish: {
    id: "languages.inSwedish",
    defaultMessage: "På svenska"
  },
  ruotsinkielinen: {
    id: "languages.ruotsinkielinen",
    defaultMessage: "ruotsinkielinen"
  },
  ruotsinkielista: {
    id: "languages.ruotsinkielista",
    defaultMessage: "ruotsinkielistä"
  },
  selection: {
    id: "languages.selection",
    defaultMessage: "Kielivalinta"
  },
  swedish: {
    id: "languages.swedish",
    defaultMessage: "ruotsi"
  },
  suomenkielinen: {
    id: "languages.suomenkielinen",
    defaultMessage: "suomenkielinen"
  },
  suomenkielista: {
    id: "languages.suomenkielista",
    defaultMessage: "suomenkielistä"
  }
});
